import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Header from "layout/settings/discoveryIgnoreList/Header";
import SubHeader from "layout/settings/discoveryIgnoreList/SubHeader";
import { createValidations } from "layout/settings/validation";
import { fetchDiscoveryIgnoreList } from "slices/settings/actions/discoveryIgnoreList";
import {
  addNewTerm,
  setEditedList,
  deleteTerm,
} from "slices/settings/slices/discoveryIgnoreSlice";
import { tableMapper } from "layout/settings/tableMapper";
import { tableVariants } from "@visiblethread/react-components/dist/components/Table/constants";
import Table, {
  styledTable,
} from "@visiblethread/react-components/dist/components/Table";
import {
  containsRowWithErrors,
  setListOnUpdate,
} from "layout/settings/tableHelpers";
import { setActiveTab } from "slices/settings/slices/activeTabSlice";
import { selectDiscoveryIgnore } from "slices/settings/selectors";

const DiscoveryIgnoreList = () => {
  const dispatch = useDispatch();
  const { editMode, ignoreList, selectedIndex } = useSelector(
    selectDiscoveryIgnore
  );

  const [rows, setRows] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(0);
  const [hasErrors, setHasErrors] = useState(false);

  const validations = createValidations({
    validateEmpty: true,
    validateLength: true,
    validateDuplicates: true,
  });

  const { getHeader, getRows, getState } = tableMapper(
    dispatch,
    editMode,
    addNewTerm,
    deleteTerm,
    validations
  );

  const setNewList = () => {
    dispatch(setEditedList(getState(rows)));
  };

  useEffect(() => {
    dispatch(fetchDiscoveryIgnoreList());
    dispatch(setActiveTab(3));
  }, [dispatch]);

  useEffect(() => {
    setSelectedRowIndex(0);
    setSelectedColumnIndex(0);
  }, [editMode]);

  useEffect(() => {
    setRows(getRows(ignoreList));
  }, [ignoreList, editMode]);

  useEffect(() => {
    setListOnUpdate(rows, getRows, ignoreList, setNewList);
    setHasErrors(containsRowWithErrors(rows));
  }, [rows]);

  useEffect(() => {
    setSelectedRowIndex(selectedIndex);
  }, [selectedIndex]);

  return (
    <>
      <Header hasErrors={hasErrors} />
      <SubHeader selectedRowIndex={selectedRowIndex} />
      <Table
        id="discovery_ignore_list-table"
        dataTestId="discovery_ignore_list-table"
        content={{ header: getHeader(), rows, setRows }}
        config={{
          variant: tableVariants.plain,
          editable: editMode,
          draggable: editMode,
          table: styledTable.excel,
          resizable: true,
          persistSettings: true,
          selectedRowIndex,
          selectedColumnIndex,
          setSelectedRowIndex,
          setSelectedColumnIndex,
        }}
      />
    </>
  );
};

export default DiscoveryIgnoreList;
